'use client';
import { useReducer } from 'react';

var useStateMachine = function(initialState, machine) {
    return useReducer(function(state, event) {
        var nextState = machine[state][event];
        return nextState != null ? nextState : state;
    }, initialState);
};

export { useStateMachine };
